import type { Testimonial } from '../types/content';
export const stats = [['3', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'Listo para usar']];
export const testimonials: Testimonial[] = [{
  name: 'Mariana V.',
  place: 'Buenos Aires',
  quote: "Me interesaba el bienestar oriental, pero encontraba información por todos lados. Tenerlo todo organizado me facilita empezar."
}, {
  name: 'Gabriela S.',
  place: 'Córdoba',
  quote: "Me gustó tener las prácticas explicadas paso a paso, sin tener que buscar videos cada vez que quiero consultarlas."
}, {
  name: 'Lucía P.',
  place: 'Rosario',
  quote: "Lo que más me gustó fue el programa de 28 días, con las actividades organizadas para saber qué práctica hacer cada día."
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Carolina R.',
  place: 'Buenos Aires',
  quote: 'Antes encontraba conceptos sobre Medicina Tradicional China, pero me costaba entender cómo se relacionaban. Tener una guía introductoria me permite consultar los fundamentos de manera ordenada.'
}, {
  name: 'Andrea F.',
  place: 'Córdoba',
  quote: 'Me resulta práctico tener las técnicas explicadas en un mismo material. Puedo volver a consultar las instrucciones cuando quiero recordar una secuencia.'
}, {
  name: 'Valeria S.',
  place: 'Mendoza',
  quote: 'El programa de 28 días me parece una forma sencilla de organizar las prácticas. Ya tengo un recorrido preparado en lugar de decidir cada día qué combinar.'
}, {
  name: 'Paula M.',
  place: 'Rosario',
  quote: 'Valoro que haya rutinas de distintas duraciones. Así puedo consultar una alternativa breve cuando estoy ocupada, sin tener que preparar todo por mi cuenta.'
}];